var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadingOxygen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#a4c0c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86,150.4a61.78,61.78,0,1,1,61.78-61.78,8,8,0,0,1-16,0A45.78,45.78,0,1,0,86,134.4a8,8,0,0,1,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.71,162.92h-21v-.48l12.15-10.37a104.52,104.52,0,0,0,8.3-7.89,24,24,0,0,0,4.49-6.62,17.87,17.87,0,0,0,1.39-7.19v-.09a16.43,16.43,0,0,0-3-9.75,19.68,19.68,0,0,0-8.28-6.53,30.57,30.57,0,0,0-12.46-2.36,28.38,28.38,0,0,0-12.43,2.62,20.55,20.55,0,0,0-8.49,7.29,19.11,19.11,0,0,0-3.07,10.76v.39h0c.14,3.24,3.33,5.83,7.26,5.83s7.28-2.71,7.28-6.05h0l0-.24a9.49,9.49,0,0,1,1.3-4.46,8.07,8.07,0,0,1,3.26-3,10.46,10.46,0,0,1,4.91-1.1,9.17,9.17,0,0,1,4.32,1,7.49,7.49,0,0,1,2.92,2.68,7.33,7.33,0,0,1,1.06,4v.09A10.15,10.15,0,0,1,135,135a15.11,15.11,0,0,1-2.71,4.13,61.59,61.59,0,0,1-5.92,5.78l-19.56,17.19a7.44,7.44,0,0,0,4.91,13h34a6.12,6.12,0,0,0,0-12.24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingOxygen);
export default __webpack_public_path__ + "static/media/Reading - Oxygen.d73597436bb7c79b28fb76b02362b618.svg";
export { ForwardRef as ReactComponent };